import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { ServicesContext } from 'services/context'
import {
  MEMBER_INVOICE_TABLE,
  MEMBER_BALANCE_HISTORY_TABLE,
} from 'constants/tables'

import { createColumns } from './columns.description'
import { createColumnsHistory } from './columnsHistory.descriptions'
import { createColumnsBankAccount } from '../../shared/columnsBankAccount.description'
import MemberInvoicesOverviewComponent from './component'

export const MemberInvoicesOverview = combine({
  hooks: [
    withTableController({ id: MEMBER_INVOICE_TABLE }),
    withTableController({ id: MEMBER_BALANCE_HISTORY_TABLE }),
    withContext(
      'adminMemberInvoiceService',
      ServicesContext,
      ({ adminMemberInvoiceService }) => adminMemberInvoiceService
    ),
    withContext(
      'adminMemberService',
      ServicesContext,
      ({ adminMemberService }) => adminMemberService
    ),
    withMemo('columns', () => createColumns(), []),
    withMemo('columnsHistory', () => createColumnsHistory(), []),
    withMemo('columnsBankAccount', () => createColumnsBankAccount(), []),
    withCallbacks(
      {
        loadMemberInvoice:
          ({ adminMemberInvoiceService }, { match }) =>
          (tableState) => {
            const memberId = Number(match.params.memberId)
            return adminMemberInvoiceService.queryMembersInvoice(memberId, {
              page: tableState.page,
              size: tableState.pageSize,
            })
          },
        loadMemberBalance:
          ({ adminMemberService }, { match }) =>
          () => {
            const memberId = Number(match.params.memberId)
            return adminMemberService.getMemberBalance(memberId)
          },
        loadMemberBalanceHistory:
          ({ adminMemberService }, { match }) =>
          () => {
            const memberId = Number(match.params.memberId)
            return adminMemberService.getMemberBalanceHistory(memberId)
          },

        getBankAcountInfo:
          ({ adminMemberService }, { match }) =>
          async () => {
            const memberId = Number(match.params.memberId)
            const content = await adminMemberService.getMemberBankAccount(
              memberId
            )
            return content
          },
      },
      []
    ),
  ],
  transformProps: ({
    match,
    loadMemberInvoice,
    columns,
    loadMemberBalance,
    loadMemberBalanceHistory,
    getBankAcountInfo,
    columnsHistory,
    columnsBankAccount,
  }) => {
    return {
      memberId: Number(match.params.memberId),
      columns,
      loadMemberInvoice,
      loadMemberBalance,
      loadMemberBalanceHistory,
      columnsBankAccount,
      columnsHistory,
      getBankAcountInfo,
    }
  },
})(MemberInvoicesOverviewComponent)
